import { Banner, isPromptBanner } from '../types/banner';

export const getDisplayContent = (banner: Banner): string => {
  if (isPromptBanner(banner)) {
    return banner.title || 'Nuevo asset';
  }

  // Para creatividades en general
  return banner.title || `Banner ${banner.bannerType}`;
};
